import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Marcus Reyes",
    profession: "Fitness Content Creator",
    earnings: "$2,400 in 90 days",
    quote: "I joined free, used the ready-made ad creatives, and hit my first payout in under three weeks. The Social Flats team also grew my Instagram by 40% — the clicks followed.",
  },
  {
    name: "Priya Sharma",
    profession: "Personal Finance Blogger",
    earnings: "$5,100 in 6 months",
    quote: "The tier system kept me motivated — I pushed from Noobie to Elite and my commission jumped to 19%. The exclusive training alone is worth more than programs I used to pay for.",
  },
  {
    name: "Daniel Kim",
    profession: "YouTube Tech Reviewer",
    earnings: "$1,850 in first 60 days",
    quote: "Access matters. Social Flats got me into affiliate programs I couldn't reach on my own, and the fast-start bonus landed in my account exactly as promised.",
  },
];

const Stars = () => (
  <div className="flex gap-0.5" aria-label="5 star rating">
    {["s1", "s2", "s3", "s4", "s5"].map((k) => <Star key={k} className="w-4 h-4 fill-amber-400 text-amber-400" />)}
  </div>
);

export const TestimonialsSection = () => (
  <section data-testid="testimonials-section" className="max-w-7xl mx-auto px-4 sm:px-8 mt-24">
    <p className="uppercase text-xs tracking-[0.2em] font-semibold text-slate-500 mb-2">Success Stories</p>
    <h2 className="font-heading text-3xl md:text-4xl tracking-tight mb-3">Real affiliates. Real payouts.</h2>
    <p className="text-slate-600 max-w-xl mb-10 leading-relaxed">Results from creators who signed up free and put our network to work.</p>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {TESTIMONIALS.map((t) => (
        <div key={t.name} data-testid={`testimonial-card-${t.name.toLowerCase().replace(/\s+/g, "-")}`} className="card-lift bg-white border border-slate-200 rounded-lg p-8 flex flex-col">
          <Quote className="w-7 h-7 text-emerald-200 mb-4" />
          <p className="text-sm text-slate-600 leading-relaxed mb-6 flex-1">"{t.quote}"</p>
          <Stars />
          <div className="flex items-end justify-between mt-4 pt-4 border-t border-slate-100">
            <div>
              <p className="font-heading font-semibold text-sm">{t.name}</p>
              <p className="text-xs text-slate-500">{t.profession}</p>
            </div>
            <span className="text-xs font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 px-3 py-1 rounded-full whitespace-nowrap">{t.earnings}</span>
          </div>
        </div>
      ))}
    </div>
  </section>
);
